import React, { useContext, useEffect, useMemo, useState } from 'react';
import pushSubscriptionService from '../services/pushSubscriptionService';
import { UserContext } from '../UserContext';

const STORAGE_KEY = 'mf_push_prompt_dismissed_v1';

export default function PushNotificationsPrompt() {
  const { userId } = useContext(UserContext);
  const [dismissed, setDismissed] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setDismissed(localStorage.getItem(STORAGE_KEY) === '1');
  }, []);

  const shouldShow = useMemo(() => {
    if (!userId) return false;
    if (dismissed) return false;
    if (!pushSubscriptionService.isSupported()) return false;
    if (!pushSubscriptionService.getVapidPublicKey()) return false;
    return Notification.permission === 'default';
  }, [userId, dismissed]);

  if (!shouldShow) return null;

  const onEnable = async () => {
    setError(null);
    setLoading(true);
    try {
      await pushSubscriptionService.requestAndSubscribe(userId);
      localStorage.setItem(STORAGE_KEY, '1');
      setDismissed(true);
    } catch (e) {
      setError(e?.message || 'Impossible d’activer les notifications.');
    } finally {
      setLoading(false);
    }
  };

  const onLater = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setDismissed(true);
  };

  return (
    <div
      style={{
        position: 'fixed',
        left: 16,
        right: 16,
        bottom: 16,
        zIndex: 99999,
        background: 'rgba(26, 0, 18, 0.92)',
        border: '1px solid rgba(255, 51, 204, 0.6)',
        borderRadius: 14,
        padding: 14,
        color: '#fff',
        boxShadow: '0 12px 40px rgba(0,0,0,0.4)',
        backdropFilter: 'blur(8px)'
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 6 }}>Activer les notifications ?</div>
      <div style={{ fontSize: 13, opacity: 0.9, marginBottom: 10 }}>
        Pour recevoir les appels entrants et nouveaux messages, même si MovieFrenzy n’est pas ouvert.
      </div>
      {error && (
        <div style={{ fontSize: 12, marginBottom: 10, color: '#ff6b6b' }}>
          {error}
        </div>
      )}
      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
        <button
          type="button"
          onClick={onLater}
          disabled={loading}
          style={{
            background: 'transparent',
            border: '1px solid rgba(255,255,255,0.25)',
            color: '#fff',
            borderRadius: 10,
            padding: '8px 12px',
            cursor: 'pointer'
          }}
        >
          Plus tard
        </button>
        <button
          type="button"
          onClick={onEnable}
          disabled={loading}
          style={{
            background: '#FF33CC',
            border: 'none',
            color: '#13000c',
            borderRadius: 10,
            padding: '8px 12px',
            cursor: 'pointer',
            fontWeight: 700
          }}
        >
          {loading ? 'Activation…' : 'Activer'}
        </button>
      </div>
    </div>
  );
}
